module.exports = __webpack_public_path__ + "img/thumbnailvideo-whitelabel.aa536de4.jpg";